import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getUsageProcessTypes from '../../services/reports/getUsageProcessTypes.js'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchUsageProcessTypesCombo () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const usageProcessTypesCombo = yield call(getUsageProcessTypes, auth.token)
    yield put(fetchCombosSuccess({ usageProcessTypesCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchUsageProcessTypesCombo () {
  yield takeLatest(combosActionTypes.FETCH_USAGE_PROCESS_TYPES_COMBO, fetchUsageProcessTypesCombo)
}
